import intermind from '../../../index';
import { ListConfig, ListParams, ListResponse } from '../../../types';
import { Payment } from '../types/payment.types';

export class PaymentResource {
  async listConfig(): Promise<ListConfig> {
    const { data } = await intermind.httpClient.get<ListConfig>('/billing/payments/list-config');
    return data;
  }

  async list(params: ListParams): Promise<ListResponse<Payment>> {
    const { data } = await intermind.httpClient.get<ListResponse<Payment>>('/billing/payments', {
      params,
    });
    return data;
  }
}
